module.exports = __webpack_public_path__ + "img/onboarding/upload-thumb-8bf4cbeab9f0d02cb25c9a216b17a7f2.svg";